import React, { memo } from 'react'
import type { Product } from '../../../modules/productsListing/types'
import type { CloudMarketplace } from '../../../types'
import { PrivateOfferActivityLog } from '../../PrivateOfferActivityLog/PrivateOfferActivityLog'
import { PrivateOfferCreationForm } from '../AzureOffer/AzurePrivateOfferCreationForm'
import { PrivateOfferFormContainer } from '../AwsOffer/PrivateOfferFormContainer'
import type { StakeholderUserOption } from '../../../common/components/ViewStakeholders/stakeholderUserOption'

export type PrivateOfferAddEditContainerProps = {
  product: Product
  conditionalClassNamesForHubspot?: {
    container?: string
    formWidth?: string
    hideActivityLog?: string
  }
  offset: number
  hideStakeholders?: boolean
  tabTop?: string
  cloud?: CloudMarketplace
  isSalesforceContext?: boolean
  stakeholderUsers?: StakeholderUserOption[]
}

const PrivateOfferAddEditContainer: React.FC<
  PrivateOfferAddEditContainerProps
> = ({
  product,
  conditionalClassNamesForHubspot,
  offset,
  hideStakeholders,
  tabTop,
  cloud,
  isSalesforceContext = false,
  stakeholderUsers = [],
}) => {
  return (
    <div className={conditionalClassNamesForHubspot?.container}>
      <div className={conditionalClassNamesForHubspot?.formWidth}>
        {cloud === 'AWS' && (
          <PrivateOfferFormContainer
            product={product}
            offset={offset}
            hideStakeholders={hideStakeholders}
            tabTop={tabTop}
            stakeholderUsers={stakeholderUsers}
          />
        )}
        {cloud === 'AZURE' && (
          <PrivateOfferCreationForm
            product={product}
            tabTop={tabTop}
            isSalesforceContext={isSalesforceContext}
            stakeholderUsers={stakeholderUsers}
          />
        )}
      </div>
      {cloud !== 'AZURE' && (
        <PrivateOfferActivityLog
          conditionalClassNamesForHubspot={conditionalClassNamesForHubspot}
        />
      )}
    </div>
  )
}

const areEqual = (
  prevProps: PrivateOfferAddEditContainerProps,
  nextProps: PrivateOfferAddEditContainerProps
) => {
  const productChanged =
    JSON.stringify(prevProps.product) !== JSON.stringify(nextProps.product)

  const otherPropsChanged =
    prevProps.conditionalClassNamesForHubspot !==
      nextProps.conditionalClassNamesForHubspot ||
    prevProps.offset !== nextProps.offset ||
    prevProps.hideStakeholders !== nextProps.hideStakeholders ||
    prevProps.tabTop !== nextProps.tabTop ||
    prevProps.cloud !== nextProps.cloud ||
    prevProps.isSalesforceContext !== nextProps.isSalesforceContext ||
    prevProps.stakeholderUsers !== nextProps.stakeholderUsers

  return !(productChanged || otherPropsChanged)
}

export const MemoizedPrivateOfferAddEditContainer = memo(
  PrivateOfferAddEditContainer,
  areEqual
)
